import { compose, mdsWidget } from 'dojo/_base/declare';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import lang from 'dojo/_base/lang';
import { HTEvPlanningCommunication } from "./ProgramBillingEditorTypes";
import ProgramBillingEditor from './ProgramBillingEditor';

class ProgramBillingFinder extends compose(FinderBaseV2) {
    //templateString = template;

    private _onClick_Row(data: StaticTable.StaticTableRow<HTEvPlanningCommunication>) {
        let entityId = data.rowGroup.entity.ID;

        this._openEditor(entityId);
    }

    private _openEditor(entityId?: string) {
        let editor = new ProgramBillingEditor();
        editor.openEditor(entityId, this.getTabContainerName());
    }

    private _onClickNewButton(e) {
        this._openEditor();
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<HTEvPlanningCommunication>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        switch (colName) {

        }

        return false;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.setupFinderWithCallfunctions(
            "Webtool_API__ProgramBillingFinder_GetProgramBillingFinderConfig",
            "Webtool_API__ProgramBillingFinder_GetProgramBillingListJSON",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this._tableFormatter)
        );

        this.createDefaultButton("new", lang.hitch(this, this._onClickNewButton));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProgramBillingFinder);